import React, { ReactNode } from 'react';
import { View, StyleSheet } from 'react-native';
import DLOHeader from './DLOHeader';
import DLOSidebar from './DLOSidebar';
import AnnouncementBanner from '../../../screens/homescreen/components/AnnouncementBanner';
import { useTheme } from '../../../theme';

interface DLOLayoutProps {
  children: ReactNode;
  activeScreen: string;
  onNavigate: (screen: string, params?: { [key: string]: any }) => void;
}

export default function DLOLayout({ children, activeScreen, onNavigate }: DLOLayoutProps) {
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      <DLOHeader onNavigate={onNavigate} />
      <AnnouncementBanner />
      <View style={[styles.mainContainer]}>
        <DLOSidebar activeScreen={activeScreen} onNavigate={onNavigate} />
        <View style={[styles.content, { backgroundColor: colors.background.page }]}>
          {children}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  mainContainer: {
    flex: 1,
    flexDirection: 'row',
    // marginTop is now applied dynamically in the component
  },
  content: {
    flex: 1,
    padding: 20,
  },
});
